var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-lock-locked-5361028",
    d: "M120.176,17.881h5.947V16a3.015,3.015,0,0,0-.874-2.124,2.935,2.935,0,0,0-4.2,0A3.017,3.017,0,0,0,120.177,16Zm6.874,0a2.663,2.663,0,0,1,1.81.8,2.726,2.726,0,0,1,.789,1.92v4.734a2.726,2.726,0,0,1-.789,1.921,2.664,2.664,0,0,1-1.9.8h-7.625a2.662,2.662,0,0,1-1.9-.8,2.726,2.726,0,0,1-.789-1.921V20.6a2.725,2.725,0,0,1,.789-1.92,2.663,2.663,0,0,1,1.81-.8V16a3.957,3.957,0,0,1,1.146-2.788,3.854,3.854,0,0,1,5.51,0A3.959,3.959,0,0,1,127.051,16v1.883Zm-.088.936h-7.625a1.745,1.745,0,0,0-1.243.524,1.787,1.787,0,0,0-.518,1.257v4.734a1.786,1.786,0,0,0,.518,1.258,1.746,1.746,0,0,0,1.243.524h7.625a1.745,1.745,0,0,0,1.243-.524,1.787,1.787,0,0,0,.518-1.258V20.6a1.784,1.784,0,0,0-.518-1.257,1.744,1.744,0,0,0-1.243-.524Z",
    transform: "translate(-116.65 -12.053)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLocked);
export default __webpack_public_path__ + "static/media/lock-locked.592aeaf405efbc6809ae0e2c0b7e201a.svg";
export { ForwardRef as ReactComponent };